
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetServerSideProps } from "next";
import type { UriPageProps } from "../client";
import type { AppProps } from "../util";
import { asCurrency, asLanguage, isLanguage } from "@broadside/common";
import { UriPage } from "../client";
import { BroadsideApi } from "../server/broadside-api";
import { CURRENCY_COOKIE, defaultCurrencyForLanguage, encodeUriPathSegments, parseCookie } from "../util";
import { Logger } from "../server/logger";
import { blockRequest } from "../request-blocking";
const isBadStatus = (status: number): boolean => {
    switch (status) {
        case 200:
        case 404:
            return false;
        default:
            return true;
    }
};
const getServerSideProps: GetServerSideProps<AppProps & UriPageProps> = async ({ params, req, res, locale: language }) => {
    const cloudfrontViewerAddress = req.headers["cloudfront-viewer-address"];
    if (blockRequest(cloudfrontViewerAddress)) {
        console.warn(`IP_BLOCK Denying request from ${cloudfrontViewerAddress} ${req.url}`); // eslint-disable-line no-console
        res.setHeader("cache-control", "no-cache");
        res.setHeader("content-type", "text/html");
        res.write("<h1>Too Many Requests</h1><p>You have made too many requests to this website. Try again later.</p>");
        res.end();
        return {} as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    }
    const uri: string = (() => {
        let uri = `${language}/`;
        if (params) {
            const segments = params.segments;
            if (Array.isArray(segments)) {
                /*
                    Workaround for issue where `segments` & `local` are not properly
                    handled for the home page when a ?query=param is included in the URL.

                    In deployments, we wind up seeing the locale detected as /en, and the
                    /language prefix as part of segments; this means we requests URIs
                    like /en/en-GB from API, which obviously is a 404.

                    So, if we find that we have a single segment which is a language code,
                    we know this should actually have been the homepage for that language.
                */
                const isBadSegments = segments.length === 1 && isLanguage(segments[0]);
                if (isBadSegments) {
                    uri = segments[0];
                }
                else {
                    // The normal behaviour.
                    uri += segments.join("/");
                }
            }
        }
        return encodeUriPathSegments(uri);
    })();
    const cookie = req.headers["cookie"] ?? "";
    const currency = parseCookie(cookie, CURRENCY_COOKIE) ?? defaultCurrencyForLanguage(language);
    const api = new BroadsideApi({
        req,
        currency: asCurrency(currency),
        language: asLanguage(language),
    });
    const [page, currencies] = await Promise.all([
        api.getUri(uri),
        api.getCurrencies(),
    ]);
    if (page.data?.type === "redirect") {
        return { redirect: page.data };
    }
    if (page.status !== 200 || page.data?.data?.noCache) {
        res.setHeader("cache-control", "no-cache");
    }
    if (isBadStatus(page.status)) {
        Logger.badStatus(req, uri, page.status);
    }
    res.statusCode = page.status;
    return { props: { page: page.data, currencies: currencies.data, cookie } };
};
export default UriPage;

    async function __Next_Translate__getServerSideProps__19aba9673da__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[[...segments]]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__19aba9673da__ as getServerSideProps }
  